/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecords.defs.js'
export * as $defs from './getRecords.defs.js'
